import { render, staticRenderFns } from "./EmailPhoneVerification.vue?vue&type=template&id=5d6d29ae"
import script from "./EmailPhoneVerification.vue?vue&type=script&lang=js"
export * from "./EmailPhoneVerification.vue?vue&type=script&lang=js"
import style0 from "./EmailPhoneVerification.vue?vue&type=style&index=0&id=5d6d29ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports